import React from 'react';

export class DropdownWithUrl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.isLoaded = false;
        this.state.data = this.props.Data;
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(e) {

        if (typeof this.props.onChange === "function")
            this.props.onChange(e.target.value, this.props.name);

    }
    componentDidMount() {

        if (this.props.url == null) {
            this.setState({
                isLoaded: true
            });
            return;
        }

        fetch(this.props.url, {
            method: 'GET',
            headers: this.props.headers
        }).then(res => {
            this.status = res.status;

            res.json().then((result) => {
                //                console.log(result);
                this.data = result;
                this.setState({
                    isLoaded: true,
                    status: res.status
                });
                //   console.log(result);
            },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,

                    });
                }
            );
        }
        );
    }

    render() {


        var divStyleOp = {

            dir: 'rtl',
            'textAlign': 'center'

        };

        if (this.state.isLoaded == false) {
            return (<div className="input-group" style={{ width: "100%" }}>
                <div className="input-group-prepend" style={{ width: "30%" }}>
                    <span className="input-group-text" style={{ width: "100%" }}>{this.props.label}</span>
                </div>
                ...
            </div>
            );
        }

        //   console.log(this.props.Data);
        if (this.data != null) {
            var options = this.data.map((data) =>
                <option style={divStyleOp} key={data.id} value={data.id}>{data.name}</option>
            );
        }
        else {
            var options = "";
        }

        var emptyOption = null;
        if (this.props.showEmptyOption === false) {

        }
        else {
            var emptyOption = <option style={divStyleOp} key={-1} value={-1}>انتخاب کنید</option>;
        }



        return (<div className="input-group" style={{ width: "100%" }}>
            <div className="input-group-prepend" style={{ width: "30%" }}>
                <span className="input-group-text" style={{ width: "100%" }}>{this.props.label}</span>
            </div>
            <select

                className="custom-select"
                value={this.props.Selected}

                ref="myRef"
                required={this.props.required}
                onChange={this.handleChange}>
                {emptyOption}
                {options}
            </select>
        </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/elements/DropdownWithUrl.js